import { VSTack } from '@esui/core/layout';
import { Route } from '@esui/core/router';
import { Button } from './index.js';

export const buttonIframeRoutes: Route[] = [
  {
    pattern: '/button/iframe(/)',
    async viewFactory() {
      return VSTack(Button('inside iframe'))
        .justifyItems('center')
        .style('padding', '1rem');
    },
  },
];
